"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.profileMatchingGlobalReportResponseSchema = exports.profileMatchingBooleanRequestResponseSchema = exports.profileMatchingRankingResponseSchema = exports.profileMatchingRankingItemSchema = exports.profileMatchingScoresSchema = void 0;
const zod_1 = require("zod");
exports.profileMatchingScoresSchema = zod_1.z
    .object({
    contract: zod_1.z.number().min(0).max(100).nullable().optional().describe('Adequation du type de contrat'),
    location: zod_1.z.number().min(0).max(100).nullable().optional().describe('Correspondance de localisation et mobilite'),
    formations: zod_1.z.number().min(0).max(100).nullable().optional().describe('Formations et diplomes'),
    habilitations: zod_1.z.number().min(0).max(100).nullable().optional().describe('Habilitations requises'),
    languages: zod_1.z.number().min(0).max(100).nullable().optional().describe('Maitrise des langues requises'),
    tools: zod_1.z.number().min(0).max(100).nullable().optional().describe('Maitrise des outils techniques'),
    domains: zod_1.z.number().min(0).max(100).nullable().optional().describe("Correspondance avec le domaine d'expertise"),
    sectors: zod_1.z.number().min(0).max(100).nullable().optional().describe("Correspondance avec les secteurs d'activite"),
})
    .describe('Sous-scores par critere');
exports.profileMatchingRankingItemSchema = zod_1.z
    .object({
    boondId: zod_1.z.string().describe('Identifiant Boond du candidat'),
    score: zod_1.z.number().min(0).max(100).describe('Score global du candidat'),
    justification: zod_1.z.string().describe('Justification concise du score'),
    scores: exports.profileMatchingScoresSchema.optional().describe('Detail des sous-scores'),
})
    .describe('Candidat classe');
exports.profileMatchingRankingResponseSchema = zod_1.z.object({
    rankings: zod_1.z.array(exports.profileMatchingRankingItemSchema).describe('Classement des candidats'),
});
exports.profileMatchingBooleanRequestResponseSchema = zod_1.z.object({
    keywords: zod_1.z
        .array(zod_1.z
        .string()
        .describe('Requete Boond precise, non generique, ordonnee du critere le plus discriminant au plus optionnel'))
        .describe('Requetes de mots-cles Boond. Le backend relache la recherche en retirant les termes de fin et choisit le volume final de candidats.'),
});
exports.profileMatchingGlobalReportResponseSchema = zod_1.z.object({
    globalReport: zod_1.z.string().describe('Rapport global synthetisant les resultats du matching'),
});
